(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/helpers/error-handlers.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/helpers/error-handlers.js');

'use strict';

const {
  showCreateTechnicalFailureDialog,
  showErrorMessageDialog,
  showSuspensionMessageDialog,
  showTechnicalError
} = svs.arena.pages.teams.dialogs;


const handleSuspensionError = () => {
  svs.core.jupiter.get('/player/1/suspensions', response => {
    showSuspensionMessageDialog(response.suspensions);
  }, error => {
    svs.arena.logger.info('Error fetching users suspensions', error);
    showTechnicalError();
  });
};
const handleCreateTeamErrorResponseFromServer = (error, syndicateName, setTeamNameError) => {
  var _error$code;
  const errorCode = (_error$code = error.code) === null || _error$code === void 0 ? void 0 : _error$code.replace(/\s/g, '');
  if (errorCode === '22115') {
    setTeamNameError(true);
  } else if (errorCode === '22122') {
    if (!svs.core.userSession.isBlocked()) {
      handleSuspensionError();
    }
  } else if (errorCode === '22123') {
    showErrorMessageDialog(null, 'Du är lagledare i för många lag.');
  } else if (errorCode === '22124') {
    showErrorMessageDialog(null, 'Du är medlem i för många lag.');
  } else {
    showCreateTechnicalFailureDialog('syndicate');
  }
  svs.arena.logger.warn("Error when creating new team", error);
};
svs.arena.pages.teams.errorHandlers = {
  handleCreateTeamErrorResponseFromServer
};

 })(window);